import { render, staticRenderFns } from "./LogisticsDetails.vue?vue&type=template&id=910ab92a&scoped=true&"
import script from "./LogisticsDetails.vue?vue&type=script&lang=js&"
export * from "./LogisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDetails.vue?vue&type=style&index=0&id=910ab92a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910ab92a",
  null
  
)

export default component.exports